import React, { useState } from "react";
import axios from "axios";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      await axios.post(`${API}/newsletter`, { email });
      setState("done");
      setEmail("");
    } catch {
      setState("idle");
    }
  };

  return (
    <section className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-12 md:py-16">
      <div className="relative overflow-hidden rounded-[2rem] bg-[var(--oz-dark)] px-6 py-12 md:px-14 md:py-16 text-center">
        <div className="absolute -top-20 -right-16 w-72 h-72 rounded-full bg-[var(--oz-gold)] blur-[120px] opacity-25" />
        <div className="relative">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-[var(--oz-gold)] mb-4">
            Newsletter
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl text-white font-medium tracking-tight max-w-xl mx-auto">
            Recevez nos conseils beauté et nos nouveautés
          </h2>
          <p className="mt-4 text-sm text-white/60 max-w-md mx-auto">
            Astuces, routines et informations sur les packs Ozentya — directement dans votre boîte mail.
          </p>

          {state === "done" ? (
            <div data-testid="newsletter-success" className="mt-8 inline-flex items-center gap-2 text-[var(--oz-gold)]">
              <CheckCircle2 className="w-5 h-5" /> Merci ! Votre inscription est confirmée.
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <div className="flex-1 flex items-center gap-2 bg-white rounded-full px-5 py-3.5">
                <Mail className="w-4 h-4 text-[var(--oz-muted)]" />
                <input
                  data-testid="newsletter-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre email"
                  className="flex-1 outline-none text-sm bg-transparent text-[var(--oz-text)]"
                />
              </div>
              <button
                data-testid="newsletter-submit"
                disabled={state === "loading"}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[var(--oz-gold)] text-white font-semibold text-sm hover:bg-[var(--oz-gold-hover)] transition-colors disabled:opacity-60"
              >
                {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : "S'inscrire"}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
